/**
 * Inicializaión de la clase ErrorDateModel, modelo de los errores de fecha
 *
 * *Set ErrorDateModel class, application error date model*
 *
 * @access public
 * @type {class}
 */
export class ErrorDateModel {
  /**
   *
   *
   * **
   *
   * @type {string} backCode
   */
  backCode: string;

  /**
   * Página del título del error de fecha
   *
   * *Error date page title*
   *
   * @type {string} pageTitle
   */
  pageTitle: string;

  /**
   * Texto No. 1 de la página del error
   *
   * *Page text #1*
   *
   * @type {string} pageText1
   */
  pageText1: string;

  /**
   * Texto No. 2 de la página del error
   *
   * *Page text #2*
   *
   * @type {string} pageText2
   */
  pageText2: string;

  /**
   * Texto contenido del error (no obligatorio)
   *
   * *Error's content text (not mandatory)*
   *
   * @type {string} contentText
   */
  timeText: string;
}
